<div class="sheet-format-editor-modal" data-testid="sheet-format-editor-modal">
  <p class="sheet-format-editor-hint">
    {{ 'labelPrinting.sheetFormatEditor.hint' | translate }}
  </p>

  <formly-form [form]="form" [fields]="fields" [model]="model" (modelChange)="onModelChange($event)" data-columns="3"
    data-testid="sheet-format-editor-form" />
</div>